module.exports = function getResource(label) {
    const resources = {
        removePhoto: 'Remove Photo',
        addPhoto: 'Add Photo',
        somethingWentWrongError: 'An error occurred during the submission process, please retry at a later time.'
    };
    return resources[label];
};
